import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Day } from 'src/main/webapp/assets/models/iter.model';

/**ToDo Documentazione */
@Component({
  selector: 'app-city',
  styleUrls: ['./city.component.scss'],
  templateUrl: './city.component.html'
})
export class CityComponent {
  @Input() public day: any;
  @Input() public version: any;
  public description: any;
  public language: string;
  @Input() public urlCitiesImages = '';
  @Input() public noImageUrl: any;
  @Input() public endDate?: string;
  @Input() public hideDate: boolean = false;
  @Input() public enableTravelStepsTab: boolean = false;

  constructor(public translateService: TranslateService) {
    this.language = translateService.currentLang;
  }

  public showCity(day: Day): boolean {
    return !!day.city_name && (day.showDetailsOnItinerary || day.isIndipendentStay);
  }

  public showLineAfter(day: Day): boolean {
    return day.cars?.length > 0 || day.flights?.length > 0 || day.transfers?.length > 0 ||
    day.hotels?.length > 0 || day.optionals?.length > 0 ||
    (day.flights?.length > 0 && day.isLastDay);
  }
}
